import { faCheckCircle } from '@fortawesome/fontawesome-free-solid'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { Fragment, useEffect, useState } from 'react'

import { Input } from '../../components/basic/input'
import { Block, Flex, Grid } from '../../components/basic/layout'
import { H1, P } from '../../components/basic/text'
import { LABELS, MESSAGES } from '../../constants'
import { Gray_100, Gray_600, Gray_700 } from '../../constants/colors'
import { setAddToCartCheck, setStep, setSubStep } from '../../context/actions'

export const Review = ({ state, dispatch }) => {
    const [reviewData, setReviewData ] = useState({})
	const mobile = state.resize < 1025
    const stringifiedState = JSON.stringify(state.choices)
    
    const textGeneralProps = { hover: Gray_700, color: Gray_700 }

    const NavigateToStep = (step, substep) => {
        setStep(dispatch, step)
        setSubStep(dispatch, substep)
    }

    useEffect(() => {
        const FormatData = () => {
            const choiceArray = Object.values(state.choices)
            let data = {}
            for(let i = 0; i < choiceArray.length; i++) {
                if(!Object.keys(data).includes(choiceArray[i].step)) {
                    data[choiceArray[i].step] = {
                        title: choiceArray[i].step,
                        subSteps: []
                    }
                }

                data[choiceArray[i].step].subSteps.push(choiceArray[i])

                data[choiceArray[i].step].subSteps?.forEach(subStepData => {
                    const formattedFields = Object.entries(subStepData?.fields).map(([key, field]) => {
                        if(field?.chosenValue && !field?.displayName){
                            const fieldRelatedFeature = subStepData?.product?.features?.find(feature => feature.featureOsr === key)

                            return [key, {...field, displayName: fieldRelatedFeature.displayName}]
                        }

                        return [key, field]
                    })

                    subStepData['fields'] = Object.fromEntries(formattedFields)
                })
            }

            return data
        }
        setReviewData(Object.values(FormatData()))
    }, [state.choices, stringifiedState])

    const handleChange = (value) => {
        setAddToCartCheck(dispatch, value)
    }

	return (
		<Block>
            {mobile
                ? <Fragment>
                    <P color="gray" hover="gray" padding="30px 20px 5px 20px">{LABELS.BUILD_YOUR_OWN_PACKAGE}</P>
                    <Flex padding="5px 20px 20px 20px" justify="flex-start" align="center">
                        <P size="20px" weight="bold" color="#095AC3" hover="#095AC3">
                            {LABELS.GENERIC.CURRENT_STEP(state.stepamount + 1)}
                        </P>
                        <P size="20px" weight="bold" margin="0 0 0 10px">{LABELS.REVIEW_AND_ORDER}</P>
                    </Flex>
                </Fragment>
                : <Block
                    padding="15px"
                    borderBottom="1px solid lightgray"
                    background={Gray_100}
                >
                    <H1 textTransform="capitalize">{LABELS.REVIEW_AND_ORDER}</H1>
                </Block>
            }
            {reviewData && (reviewData.length > 0)
                && reviewData.map((step, key) => (
                    <Block
                        borderTop="1px solid lightgray"
                        padding={!mobile ? "30px" : "20px"}
                        key={`Review-Step-${step.title}-${key}`}
                    >
                        <Flex width="auto" align="flex-start" justify="space-between">
                            <P flex="auto" margin="0 0 15px 0" weight="bold" size="16px">{step.title}:</P>
                            <P line="16px" size="16px" color="green" hover="green">
                                <FontAwesomeIcon icon={faCheckCircle} />
                            </P>
                        </Flex>
                        {step.subSteps.map((substep, subkey) => (
                            <Flex
                                align="flex-start"
                                key={`Review-Substep-${subkey}`}
                            >
                                <Block margin="0 0 15px 0">
                                    {
                                        mobile && state.resize < 450 ?
                                            <Flex justify="flex-start" width="300px">
                                                <Block wordWrap="break-word">
                                                    <P {...textGeneralProps} margin="0 10px 0 0" weight="bold">{substep.title}:</P>
                                                    <P {...textGeneralProps} margin="0 10px 0 0">{substep.product?.displayName ? substep.product.displayName : substep.product.productName}</P>
                                                    <P {...textGeneralProps}>+${substep.basePrice.toFixed(2)}</P>
                                                </Block>
                                            </Flex>
                                            :
                                            <Flex justify="flex-start" flexWrap="wrap">
                                                <P {...textGeneralProps} margin="0 10px 0 0" weight="bold">{substep.title}:</P>
                                                <P {...textGeneralProps} margin="0 10px 0 0">{substep.product?.displayName ? substep.product.displayName : substep.product.productName}</P>
                                                <P {...textGeneralProps}>+${substep.basePrice.toFixed(2)}</P>
                                            </Flex>
                                    }
                                    {Object.values(substep.fields).map((field, fieldkey) => {                     
                                        if(!field || field?.chosenOption?.optionOsr === 'NONE') return undefined

                                        const isTextField = field.displayType === 'INSCRIPT'
                                        const hasAdjustmentPrice = field?.chosenOption?.adjustmentPrice
                                        const shouldDisplayAdjustmentPrice = (isTextField && field.chosenValue || !isTextField) && hasAdjustmentPrice

                                        return (
                                            <Flex
                                                margin="10px 0 0 0"
                                                justify="flex-start"
                                                key={`Review-Fields-${fieldkey}`}
                                                flexWrap="wrap"
                                            >
                                                {
                                                    field && field.displayName && field.chosenValue
                                                        ? <P {...textGeneralProps} margin="0 10px 0 0">{field.displayName}:</P>
                                                        : field && field.featureName && field.chosenValue && <P {...textGeneralProps} margin="0 10px 0 0">{field.featureName}:</P>
                                                }
                                                {
                                                    (field && !isTextField && field.chosenOption && field.chosenOption.displayName)
                                                        ? <P {...textGeneralProps}>{field.chosenOption.displayName}</P>
                                                        : <P {...textGeneralProps}>{field.chosenValue}</P>
                                                }
                                                {
                                                    (shouldDisplayAdjustmentPrice)
                                                        ? <P {...textGeneralProps} margin="0 0 0 10px">+${field.chosenOption.adjustmentPrice.toFixed(2)}</P>
                                                        : <P {...textGeneralProps} margin="0 0 0 10px"></P>
                                                }
                                            </Flex>
                                        )
                                    })}
                                </Block>
                                <P
                                    onClick={() => NavigateToStep(step.title, substep.title)}
                                    cursor="pointer"
                                    margin="0 0 0 0"
                                    decoration="underline"
                                    color="#095AC3"
                                >
                                    {LABELS.BUTTONS.EDIT}
                                </P>
                            </Flex>
                        ))}
                    </Block>
                ))}
            <Block padding={!mobile ? "30px" : "20px"}>
                <Grid columns="3% 97%">
                    <Input 
                        type="checkbox" 
                        checked={state.addToCartCheck} 
                        onChange={data => handleChange(data.target.checked)} 
                        legend="Review"
                    />
                    <P margin="0 0 0 15px" color={Gray_600} hover={Gray_600}>
                        {MESSAGES.CHECK_INFORMATION_ACTUALITY}
                    </P>
                </Grid>
            </Block>
        </Block>
	)
}
